import React, { useState } from 'react';
import ProductCard from '../Secciones/Productos/TarjetaProducto';
import styles from './Catalogo.module.css';

const PAGE_SIZE = 4;

const ArrowLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const CarruselRelacionados = ({ currentSlug, categorySlug, products }) => {
  const [page, setPage] = useState(0);

  const related = products.filter(
    p => p.category_slug === categorySlug && p.slug !== currentSlug
  );

  if (related.length === 0) return null;

  const totalPages = Math.ceil(related.length / PAGE_SIZE);
  const visible = related.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);

  return (
    <section className={styles.carouselSection}>
      <div className="container">
        <h2 className={styles.carouselTitle}>También te puede interesar</h2>

        <div className={styles.carouselTrack}>
          {visible.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {totalPages > 1 && (
          <div className={styles.carouselNav}>
            <button
              className={styles.carouselBtn}
              onClick={() => setPage(p => p - 1)}
              disabled={page === 0}
              aria-label="Página anterior"
            >
              <ArrowLeft />
            </button>
            <button
              className={styles.carouselBtn}
              onClick={() => setPage(p => p + 1)}
              disabled={page >= totalPages - 1}
              aria-label="Página siguiente"
            >
              <ArrowRight />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default CarruselRelacionados;
